import React from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export interface Column<T> {
  header: string;
  accessor: keyof T | ((item: T) => React.ReactNode);
  className?: string;
}
interface DataTableProps<T> {
  columns: Column<T>[];
  data: T[];
  onRowClick?: (item: T) => void;
  emptyMessage?: string;
  isLoading?: boolean;
}
export function DataTable<T extends {
  id: string | number;
}>({
  columns,
  data,
  onRowClick,
  emptyMessage = 'No records found',
  isLoading = false
}: DataTableProps<T>) {
  if (isLoading) {
    return <div className="w-full h-48 flex items-center justify-center bg-white border border-gray-200 rounded-lg" data-id="element-81">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#1B6B3A]" data-id="element-82"></div>
      </div>;
  }
  return <div className="overflow-x-auto border border-gray-200 rounded-lg shadow-sm" data-id="element-83">
      <table className="min-w-full divide-y divide-gray-200" data-id="element-84">
        <thead className="bg-gray-50" data-id="element-85">
          <tr data-id="element-86">
            {columns.map((col, idx) => <th key={idx} scope="col" className={`px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider ${col.className || ''}`} data-id="element-87">
                {col.header}
              </th>)}
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200" data-id="element-88">
          {data.length > 0 ? data.map(item => <tr key={item.id} onClick={() => onRowClick && onRowClick(item)} className={`
                  ${onRowClick ? 'cursor-pointer hover:bg-gray-50 transition-colors' : ''}
                `} data-id="element-89">
                {columns.map((col, idx) => <td key={idx} className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-90">
                    {typeof col.accessor === 'function' ? col.accessor(item) : item[col.accessor] as React.ReactNode}
                  </td>)}
              </tr>) : <tr data-id="element-91">
              <td colSpan={columns.length} className="px-6 py-12 text-center text-gray-500" data-id="element-92">
                {emptyMessage}
              </td>
            </tr>}
        </tbody>
      </table>
    </div>;
}